import React from 'react';
import Tooltip from '@mui/material/Tooltip';
import classNames from 'classnames';
import AttributeIcon, { AttributeIconSize } from '@/components/AttributeIcon';
import type SearchConstituent from '@/types/api/SearchConstituent';
import filterConstituentCategoryIcons from '@/utils/filterConstituentCategoryIcons';

function ConstituentIconTiles({
  className = '',
  constituent,
  size = AttributeIconSize.SMALL,
}: {
  className?: string;
  constituent: SearchConstituent;
  size?: AttributeIconSize;
}) {
  const icons = React.useMemo(
    () => filterConstituentCategoryIcons(constituent),
    [constituent],
  );

  return icons.length ? (
    <div
      className={classNames(
        'flex flex-wrap items-start gap-1 leading-none',
        className,
      )}
    >
      {icons.map(({ iconType, value, label }) => (
        <Tooltip title={label} key={label} arrow>
          <div key={value} className="flex-shrink-0">
            <AttributeIcon type={iconType} size={size} />
          </div>
        </Tooltip>
      ))}
    </div>
  ) : null;
}

export default ConstituentIconTiles;
